import { useCallback } from 'react';

import { useSelector, useDispatch } from '@tmapy/redux';
import { Checkbox, CheckboxProps } from '@tmapy/style-guide';

import './Filters.scss';

import { actionLoadData, actionSetEndpointQuery } from '../actions';
import { EDAS_FILTER, EDAS_TYPE, ENDPOINT_CATALOG_DATA } from '../constants';

import { lastCatalogUrlState } from './CatalogList';

const getTypeColor = (key: EDAS_TYPE) => {
  switch (key) {
    case EDAS_TYPE.mapApp:
      return 'rgb(2, 118, 177)';
    case EDAS_TYPE.dataset:
      return 'rgb(79, 158, 0)';
    case EDAS_TYPE.app:
      return 'rgb(204, 112, 0)';
  }
};

export const Filters: React.FC = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.edas.appData.data.filters);
  const query = useSelector((state) => state.edas.catalogData.query);
  const handleCheckboxClick: CheckboxProps<Record<string, string[]>>['onChange'] = useCallback(
    (e, { data }) => {
      dispatch(actionSetEndpointQuery({ endpoint: ENDPOINT_CATALOG_DATA, query: data }));
      dispatch(
        actionLoadData({
          endpoint: ENDPOINT_CATALOG_DATA,
          scroll: lastCatalogUrlState.state.scroll,
        }),
      );
    },
    [dispatch],
  );
  return (
    <aside className='sg-u-vs-4'>
      {Object.entries(filters).map(([key, value]) => {
        // show only if has 2 and options?
        const minCount = key === EDAS_FILTER.TYPE || key === EDAS_FILTER.OPEN_DATA ? 1 : 0;

        return (
          value.values.length > minCount && (
            <div key={key}>
              <h6 className='e-filter--label sg-u-type-h5'>{value.title}</h6>
              <ul className='e-filter--list sg-a-mt-1/2'>
                {value.values.map((item) => {
                  const value = `${item.value}`;
                  const currentValue = query[key] ?? [];
                  const isChecked = currentValue.includes(value);
                  const newValue = isChecked
                    ? currentValue.filter((val) => val !== value)
                    : [...currentValue, value];
                  const newQuery = { [key]: newValue };
                  return (
                    <li key={`filter-${key}-${item.value}`} className='sg-a-mt-1'>
                      <Checkbox
                        name={key}
                        value={value}
                        isChecked={isChecked}
                        color={key === 'record_types' ? getTypeColor(item.value as any) : undefined}
                        onChange={handleCheckboxClick}
                        data={newQuery}
                      >
                        <div className='sg-u-type-xsm'>{item.label}</div>
                      </Checkbox>
                    </li>
                  );
                })}
              </ul>
            </div>
          )
        );
      })}
    </aside>
  );
};
